import { isNonNaNNumber, matchKeysOnly, onOff, } from '@iotv/iotv-v3-types';
import { AppLocalStorage } from '../../../../../../data/LocalStorage/AppLocalStorage';
import { NavSections } from '../../../../../../components/navigation/NavSections';
import { createContext } from 'react';
import { SupportedPayloadDefinitions } from '@iotv/lfc-devices';
import { between } from '@iotv/core-services';
/** Originally and currently tied to ValveAct and written to be made generic in the future, Provisional implementation of generic now in ../Generics/GenericControlReducerContext */
const RangeLimits = SupportedPayloadDefinitions.ValveActPayloadDefinition.downlink.downLinkRangeLimits;
const supportedKeysNumerical = [
    'accelerometerThreshold',
    'appCycleTime',
    'boostVoltage',
    'operateValve',
    'sendConfig',
    'sysCycleTime',
    'valveOffPulses',
    'valveOnPulses',
    'buttonTime',
    'adjustTimeSecs',
];
const supportedKeysMap = ['setOptions'];
export const defaults = {
    appCycleTime: 1,
    sysCycleTime: 60,
    accelerometerThreshold: 1,
    operateValve: onOff.OFF,
    valveOnPulses: 1,
    valveOffPulses: 1,
    boostVoltage: 2,
    sendConfig: true,
    sendSettings: true,
    reboot: true,
    restoreDefaults: true,
    resetAllPatterns: true,
    stopAllPatterns: true,
    buttonTime: 1,
    adjustTimeSecs: 0,
    setOptions: {
        acceleromterEvents: 1,
        acceleromterReclose: 1,
        boostEnable: 1,
        debug: 0,
        extendAppDelay: 1,
        moisture: 1,
        octants: 1,
        octantsType: 0,
        privateNetwork: 0,
        RFU1: 0,
        RFU2: 0,
        RFU3: 0,
        RFU4: 0,
        RFU5: 0,
        RFU6: 0,
        senseCurrent: 1,
    },
};
const isDeviceOptionsMap = (x) => {
    const c = x;
    return !!c && matchKeysOnly(defaults.setOptions, x) && Object.values(x).every((v) => v === 1 || v === 0);
};
export const defaultSettings = AppLocalStorage.get(NavSections.THINGVIEW, 'lfcSolenoidControllerSettings') ?? defaults;
const originalValueSettings = Object.fromEntries(Object.entries(defaultSettings).map(([k, v]) => [k, { value: v, include: false }]));
export const defaultState = {
    payloadRequestObject: {},
    valueSettings: originalValueSettings,
};
const isUpdateValueAction = (x) => {
    const c = x;
    return (!!c &&
        c.type === 'UpdateValue' &&
        typeof c.update.key === 'string' &&
        supportedKeysNumerical.includes(c.update.key) &&
        typeof defaultSettings[c.update.key] === 'number' &&
        isNonNaNNumber(c.update.v));
};
const isUpdateMapAction = (x) => {
    const c = x;
    return (!!c &&
        c.type === 'UpdateMap' &&
        typeof c.update.key === 'string' &&
        typeof c.update.key === 'string' &&
        supportedKeysMap.includes(c.update.key) &&
        typeof defaultSettings[c.update.key] === 'object' &&
        typeof c.update.v === 'object');
};
const isTogglePresenceAction = (x) => {
    const c = x;
    return !!c && c.type === 'TogglePresence' && typeof c.update.key === 'string';
};
const isClearDownlinkObjectAction = (x) => {
    const c = x;
    return !!c && c.type === 'ClearDownlinkObject' && c.update === null;
};
export const reducer = (prev, action) => {
    console.log(`INFO: CommonControlReducer action`, action);
    const update = { ...prev };
    if (isUpdateValueAction(action)) {
        const { key, v } = action.update;
        const applicableMetadata = RangeLimits[key];
        if (applicableMetadata?.attributeType === 'number') {
            /** TODO: pretty sure there is a validator for downlink metadata */
            const { range: { min, max }, } = applicableMetadata;
            if (between(v, min, max)) {
                update.valueSettings[key].value = v;
            }
            else {
                console.log(`WARN: User set ${key} to ${v} which is outside range`, [min, max]);
            }
        }
        else {
            update.valueSettings[key].value = v;
        }
    }
    else if (isUpdateMapAction(action)) {
        const { key, v } = action.update;
        if (isDeviceOptionsMap(v)) {
            update.valueSettings[key].value = v;
        }
        else {
            console.log(`WARN, not deviceOptionsMap`, v);
        }
    }
    else if (isTogglePresenceAction(action)) {
        const { key } = action.update;
        console.log(`INFO: CommonControlReducer`, action, update.valueSettings[key].include);
        update.valueSettings[key].include = !update.valueSettings[key].include;
    }
    else if (isClearDownlinkObjectAction(action)) {
        update.payloadRequestObject = {};
        update.valueSettings = Object.fromEntries(Object.entries(update.valueSettings).map(([k, v]) => [k, { ...v, include: false }]));
    }
    else {
        console.log(`WARN: action fell through CommonControlReducer`, action);
    }
    update.payloadRequestObject = Object.fromEntries(Object.entries(update.valueSettings)
        .filter(([k, v]) => v.include === true)
        .map(([k, v]) => [k, v.value]));
    return update;
};
export const CommonControlContext = createContext({
    state: defaultState,
    dispatch: (action) => {
        throw new Error(`Don't use uninitialized dispatch for CommonControlContext`);
    },
});
